import { workSheetConstants } from '../../_constants';

const initialState = { orientationLoading: true, orientationData: [], orientationError: false };

export function worksheetOrientationReducer(state = initialState, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_ORIENTATION_WORKSHEET:
            return {
                orientationLoading: true,
                orientationData: '',
                orientationError: false
            };
        case workSheetConstants.RECEIVE_ORIENTATION_WORKSHEET:
            return {
                orientationLoading: false,
                orientationData: [...state.orientationData, action.orientation],
                orientationError: false
            };
        case workSheetConstants.ERROR_ORIENTATION_WORKSHEET:
            return {
                orientationLoading: false,
                orientationData: '',
                orientationError: true
            };
        default:
            return state
    }
}

export function worksheetOrientationReducerSingle(state = { orientationLoading: true, orientationData: [], orientationError: false }, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_ORIENTATION_WORKSHEET:
            return {
                orientationLoading: true,
                orientationData: '',
                orientationError: false
            };
        case workSheetConstants.RECEIVE_ORIENTATION_WORKSHEET:
            return {
                orientationLoading: false,
                orientationData: action.orientation.orientation.data.response,
                orientationError: false
            };
        case workSheetConstants.ERROR_ORIENTATION_WORKSHEET:
            return {
                orientationLoading: false,
                orientationData: '',
                orientationError: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/orientationWorksheet.reducer.js